import type { CSSProperties, FunctionComponent, RefObject } from 'react';
import map from 'lodash/map';
import * as styles from './AdminSelect.module.css';

type AdminSelectProps = {
  name: string;
  label: string;
  list: Record<string, string>[];
  selected: string;
  selectLabel: string;
  handleChange: () => void;
  style?: CSSProperties;
  disabled?: boolean;
  error?: string;
  propRef?: RefObject<HTMLSelectElement>;
  dataRecurly?: string;
};

const AdminSelect: FunctionComponent<AdminSelectProps> = ({
  name,
  label,
  list,
  selected,
  selectLabel,
  handleChange,
  style,
  disabled,
  error,
  propRef,
  dataRecurly,
}) => {
  return (
    <div className={styles.container} style={style}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      <select
        className={`${styles.select} ${error ? styles.error : ''}`}
        name={name}
        value={selected}
        onChange={handleChange}
        disabled={disabled}
        ref={propRef}
        data-recurly={dataRecurly}
      >
        {selectLabel && <option value="">{selectLabel}</option>}
        {map(list, (item) => (
          <option key={item.id || item.value} value={item.id || item.value}>
            {item.name ? item.name : item.displayName}
          </option>
        ))}
      </select>
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
};

export default AdminSelect;
